<template>
    <div class="product | u-wizard-padding-bottom">
        <div class="product__title">
            <h2>{{ trans('order.your-order') }}</h2>
        </div>

        <div class="select--customer" v-if="customers.length">
            <single-select
                v-model="customer"
                :options="customers"
                :placeholder="trans('order.customer-placeholder')"
                optionLabel="name"
                optionValue="id"
                name="customer"
                class="u-full-width"
                required
            />
        </div>

        <div v-if="mollieUrl" class="alert alert--danger alert--responsive | u-margin-bottom">
            <span class="u-margin-bottom-responsive">{{ trans('order.mollie-validation-message') }}</span>

            <a :href="mollieUrl" class="btn btn--blue btn--small" dusk="mollie-validation-button">
                {{ trans('order.mollie-validation-button') }}
            </a>
        </div>

        <domain-overview v-for="domain in domains" :key="domain.domain" :domain="domain" />

        <div v-if="orderTotalPrice" class="product__totals">
            <span class="product__totals-content">
                <small class="u-margin-right">{{ trans('order.total') }}</small>
                <price-display :price="orderTotalPrice" class="product__totals-price" />
            </span>

            <span v-if="!isValidated" class="product__totals-content">
                <small class="u-margin-right">{{ trans('order.total') }} {{ trans('order.with-tax') }}</small>
                <price-display :price="orderTotalPriceWithTax" class="product__totals-price" />
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DomainOverview from './DomainOverview.vue';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';

export default {
    components: {
        DomainOverview,
        PriceDisplay
    },
    props: {
        domain: {
            type: Object,
            required: false,
            default: () => {}
        },
        customers: {
            type: Array,
            required: false,
            default: () => []
        },
        mollieUrl: {
            type: String,
            required: false
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            customer: null
        };
    },
    computed: {
        ...mapGetters({
            orderDomains: 'order/domains',
            orderTotalPrice: 'order/totalPrice',
            orderTotalPriceWithTax: 'order/totalPriceWithTax',
            user: 'user/user',
            currentCustomer: 'user/currentCustomer'
        }),
        /**
         * Get domains. Supports displaying of a single domain through a property, otherwise vuex is used.
         *
         * @return {array}
         */
        domains() {
            return this.orderDomains;
        },
        /**
         * Check if user is validated.
         *
         * @return {boolean}
         */
        isValidated() {
            if (this.currentCustomer) {
                return this.currentCustomer.isValidated;
            }

            return false;
        }
    },
    watch: {
        /**
         * On update domainname enable check button
         *
         * @param {string} customerId
         */
        customer(customerId) {
            this.$emit('setCustomer', customerId);
        }
    }
};
</script>
